<template>
  <div class="countdown-timer rounded bg-gray-50 py-5 pl-5 pr-3 flex flex-row relative border-t border-l border-r border-neutral-200 overflow-hidden">
    <div class="text-left">
      <p class="flex items-center gap-2 pb-1 whitespace-no-wrap">
        <span class="countdown-timer-title font-display font-extrabold ota-p16 text-orange-600 rounded-2xl py-1" v-text="title" />
        <OSvg svg="clock" class="fill-orange-600" />
      </p>
      <span class="font-body text-neutral-800 text-xs" v-text="description" />
    </div>
    <client-only>
      <div class="ml-auto flex flex-row">
        <div class="countdown-timer-box mr-half">
          <span class="countdown-timer-box-number">{{ formattedTimeRemaining.minutes }}</span>
          <span class="countdown-timer-box-label uppercase">Min</span>
        </div>
        <div class="countdown-timer-box">
          <span class="countdown-timer-box-number">{{ formattedTimeRemaining.seconds }}</span>
          <span class="countdown-timer-box-label uppercase">Sec</span>
        </div>
      </div>
    </client-only>
    <div class="absolute bottom-0 right-0 left-0">
      <div class="meter-bar overflow-hidden mt-3">
        <div class="meter-bar-filler" :style="{ width: `${fillerWidth}%` }" />
      </div>
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'CountdownTimer',
  components: {
    OSvg
  },
  props: {
    timeRemaining: {
      type: Number,
      required: true
    },
    fillerWidth: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedTimeRemaining () {
      const minutes = Math.floor((this.timeRemaining % 3600) / 60)
      const seconds = this.timeRemaining % 60

      return {
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0')
      }
    },
    countdownExpired () {
      return this.timeRemaining <= 0
    }
  }
}
</script>

<style scoped lang="postcss">
.countdown-timer {
  &-title {
    padding: .3rem 0;
    border-radius: .5rem;
  }

  &-box {
    @apply bg-white border border-neutral-200 flex flex-col justify-center;
    min-width: 5rem;
    min-height: 5rem;
    border-radius: .6rem;

    &-number {
      @apply font-display font-extrabold text-center;
      font-size: 1.8rem;
    }

    &-label {
      @apply font-display font-semibold text-center text-neutral-600;
      font-size: 1rem;
    }
  }

  .meter-bar {
    @apply relative;
    border-radius: 1rem;
    height: 3px;

    &-filler {
      @apply absolute left-0 h-full bg-orange-600;
      border-top-right-radius: 9999px;
      border-bottom-right-radius: 9999px;
      width: 0%;
      -webkit-transition: width 1s ease-in-out;
      -moz-transition: width 1s ease-in-out;
      -o-transition: width 1s ease-in-out;
      transition: width 1s ease-in-out;
    }
  }
}
</style>
